function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-credit-card",
  "data-name": "Icon awesome-credit-card",
  d: "M0,22.143A2.388,2.388,0,0,0,2.387,24.53H26.259a2.388,2.388,0,0,0,2.387-2.387V13.39H0Zm9.549-3.382a.6.6,0,0,1,.6-.6h6.764a.6.6,0,0,1,.6.6V20.75a.6.6,0,0,1-.6.6H10.145a.6.6,0,0,1-.6-.6Zm-6.366,0a.6.6,0,0,1,.6-.6H7.36a.6.6,0,0,1,.6.6V20.75a.6.6,0,0,1-.6.6H3.78a.6.6,0,0,1-.6-.6ZM28.646,4.637V7.024H0V4.637A2.388,2.388,0,0,1,2.387,2.25H26.259A2.388,2.388,0,0,1,28.646,4.637Z",
  transform: "translate(0 -2.25)",
  fill: "#bcc3cd"
});

var SvgCard = function SvgCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.646,
    height: 22.28,
    viewBox: "0 0 28.646 22.28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card.d752520a.svg";
export { ForwardRef as ReactComponent };